import { render, staticRenderFns } from "./brief.vue?vue&type=template&id=d46cb51c&scoped=true&"
import script from "./brief.vue?vue&type=script&lang=js&"
export * from "./brief.vue?vue&type=script&lang=js&"
import style0 from "./brief.vue?vue&type=style&index=0&id=d46cb51c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46cb51c",
  null
  
)

export default component.exports